import { SignalSharingFilters, signalSharingStore } from '../../../ng-services/social-trading/signal-sharing.store';
import { AbstractTableFiltersComponent } from '../table-components/abstract-filter-handler.component';

export class SignalSharingComponent extends AbstractTableFiltersComponent<SignalSharingFilters> {
    private showFilters!: boolean;
    private showGauges!: boolean;
    private infiniteScroll!: boolean;

    $onInit() {
        this.initialFilter ??= {};
        this.showFilters ??= true;
        this.showGauges ??= true;
        this.infiniteScroll ??= true;
        this.updateFiltersFromUrl();
    }

    getFilterKeyObject() {
        return {
            signal_name: true,
            symbol: true,
            group: true,
            date_lower: true,
            date_upper: true,
            author: true,
            user: true,
            webinar: true,
        };
    }

    get store() {
        return signalSharingStore.items;
    }
}

angular.module('tradersyard').component('tySignalSharingComponent', {
    // language=HTML
    template: `
        <ty-default-rsi-gauge-row ng-if="$ctrl.showGauges"/>
        <ty-signal-sharing-table-filters ng-if="$ctrl.showFilters" filters="$ctrl.filters" on-change="$ctrl.onFiltersChanged(newFilters)"/>
        <ty-signal-sharing-table-component has-sticky-header="$ctrl.hasStickyHeader"/>
        <ty-next-page-observer paginated-store="$ctrl.store" ng-if="$ctrl.infiniteScroll"/>
    `,
    controller: SignalSharingComponent,
    bindings: {
        initialFilter: '<?',
        showFilters: '<?',
        showGauges: '<?',
        infiniteScroll: '<?',
        hasStickyHeader: '<',
    },
});
